import request from "./request";
import getLoginToken from "./getLoginToken";

function getUrl(subUrl) {
  const token = getLoginToken();
  return `${subUrl}?token=${token}&language=de`;
}

export async function doCompanySearch({ data }) {
  const url = getUrl("/company_search");

  const resp = await request.post({
    url,
    data,
    ensureURLSingleRequest: true,
  });
  return resp;
}

export async function doSingleCompanySearch({ id }) {
  const url = getUrl(`/company_search/${id}`);
  const resp = await request.get({
    url,
  });
  return resp;
}

export async function doLogin(data) {
  const resp = await request.post({
    url: "/auth/login",
    data,
  });
  localStorage.setItem("token", resp.token);
  localStorage.setItem("last_usage", resp.last_usage);
  localStorage.setItem("export_allowed", resp.export_allowed);
}

export async function checkToken() {
  const url = getUrl("/channels");
  try {
    await request.get({
      url,
    });

    // await request.get({
    //   isRealUrl: true,
    //   external: true,
    //   url: `https://dakaround-v2.stp-bi.de/app/v1/channels?token=tJvWCeitpx9Cs2hSQx7Y&language=de`,
    // });
    return true;
  } catch (e) {
    return false;
  }
}

export function getChannelList() {
  const url = getUrl("/channels");
  return request.get({
    url,
  });
  // return request.get({
  //   isRealUrl: true,
  //   external: true,
  //   url: `https://dakaround-v2.stp-bi.de/app/v1/channels?token=tJvWCeitpx9Cs2hSQx7Y&language=de`,
  // });
}

export async function getEventsForFavCompanies({ startDate, endDate }) {
  const url = getUrl("/company_events");
  if (startDate && endDate) {
    return request.get({
      url,
      ensureURLSingleRequest: true,
      query: {
        start_date: startDate,
        end_date: endDate,
      },
    });
  }
}

export async function getEvents({ channels, coordinates, dateRange }) {
  const { start_lat = 0.1, start_lon = 0.1, end_lat = 99.9, end_lon = 99.9 } = coordinates || {};
  const { startDate, endDate } = dateRange;
  const url = getUrl("/events");
  if (start_lat && start_lon && end_lat && end_lon) {
    return request.get({
      url,
      ensureURLSingleRequest: true,
      query: {
        channels: channels.join(","),
        start_lat,
        start_lon,
        end_lat,
        end_lon,
        start_date: startDate,
        end_date: endDate,
      },
    });
    // return request.get({
    //   url: `https://dakaround-v2.stp-bi.de/app/v1/events?token=tJvWCeitpx9Cs2hSQx7Y&language=de`,
    //   registerRequest,
    //   isRealUrl: true,
    //   external: true,
    //   query: {
    //     channels: channels.join(","),
    //     start_lat,
    //     start_lon,
    //     end_lat,
    //     end_lon,
    //     start_date: startDate,
    //     end_date: endDate,
    //   },
    // });
  }
}

export async function getEvent(id) {
  const url = getUrl(`/events/${id}`);
  return request.get({
    url,
  });
  // return request.get({
  //   isRealUrl: true,
  //   external: true,
  //   url: `https://dakaround-v2.stp-bi.de/app/v1/events/${id}?token=tJvWCeitpx9Cs2hSQx7Y&language=de`,
  // });
}

export async function sendEmail(email) {
  const data = {
    email,
    channels:
      "ceo_change,co_anni,co_change,co_move,co_new,inso_new,job_offer,sh_change,trainee_company,trainee_job_offer",
    start_lat: 49.133561516647575,
    start_lon: 6.233757078229246,
    end_lat: 49.49881172265427,
    end_lon: 7.4841385479558085,
    start_date: "2020-03-17",
    end_date: "2020-03-31",
    language: "de",
    limit: 5,
  };
  const url = getUrl(`/test_emails`);
  return request.post({
    url,
    data,
  });
}

// lat and other queries are missing
// need a better documentation of api
export async function searchCompanies(q) {
  const url = getUrl("/companies/search/live");
  return request.get({
    url,
    query: { q },
  });
}

export async function getCompany(id) {
  const url = getUrl(`/companies/${id}`);
  return request.get({
    url,
  });
}

export async function getSavedSection() {
  const url = getUrl("/star");
  return request.get({
    url,
  });
}

export async function saveSection(query) {
  const url = getUrl("/star");
  return request.post({
    url,
    query,
  });
}

export async function deleteSaveSection() {
  const url = getUrl("/star");
  return request.del({
    url,
  });
}

export async function getCompanyFavourites() {
  const url = getUrl("/company_stars");
  return request.get({
    url,
  });
}

export async function setCompanyFavourite(company_id) {
  const url = getUrl(`/company_stars`);
  return request.post({
    url,
    query: {
      company_id,
    },
  });
}

export async function setCompanyFavouriteGRSDB(company) {
  const url = getUrl(`/company_stars_grsdb`);
  return request.post({
    url,
    data: {
      company,
    },
  });
}

export async function deleteCompanyFavourites(companyId) {
  const url = getUrl(`/company_stars/${companyId}`);
  return request.del({
    url,
  });
}

export async function deleteCompanyFavouritesGRSDB(companyId) {
  const url = getUrl(`/company_stars_grsdb/${companyId}`);
  return request.del({
    url,
  });
}

export async function getCompanyEvents(companyId) {
  if (!companyId) {
    return null;
  }
  const url = getUrl(`/events/bisnode/${companyId}`);
  return request.get({
    url,
  });
}

export async function getFilters() {
  const url = getUrl(`/get_user_filetrs/0`);
  try {
    const list = await request.get({
      url,
    });
    return list.map(l => ({ ...l, filters: JSON.parse(l.filters) }));
  } catch (e) {
    throw e;
  }
}

export async function createFilter(filters) {
  const url = getUrl(`/manage_user_filetrs/`);
  try {
    const filter = await request.post({
      url,
      data: { filters: JSON.stringify(filters) },
    });
    return { ...filter, filters: JSON.parse(filter.filters) };
  } catch (e) {
    throw e;
  }
}

export async function updateFilter(filterId, filters) {
  const url = getUrl(`/manage_user_filetrs/`);
  try {
    const filter = await request.put({
      url,
      data: { filter_id: filterId, filters: JSON.stringify(filters) },
    });
    return { ...filter, filters: JSON.parse(filter.filters) };
  } catch (e) {
    throw e;
  }
}

export async function deleteFilter(filterId) {
  const url = getUrl(`/manage_user_filetrs/`);
  return request.del({
    url,
    data: { filter_id: filterId },
  });
}
